import React, { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router"
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from "react-redux"
import { Dropdown } from 'react-bootstrap'
import Select from 'react-select'
import XLSX from 'xlsx'

import Rightbar from 'pages/main/documentsIn/Rightbar'
import TransferBranchModal from 'pages/main/documentsIn/TransferBranchModal'
import DeleteModal from 'pages/parts/DeleteModal'
import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import PeriodPicker from 'pages/parts/PeriodPicker'
import useFilterSearchPagination from 'pages/parts/useFilterSearchPagination'
import DocumentStatusHistory from 'pages/parts/DocumentStatusHistory'
import DocumentRevisions from 'pages/parts/DocumentRevisions'

import { httpOk, GET, DELETE } from 'helpers/api'
import { SET_FILTER_DATA } from "store/filterData/actions"
import { SET_TRANSFER_DATA } from "store/transferData/action"
import { formatDate, formatMoney, returnSign, findKeyFromArrayByValue, arrayJoin, PAGE_SIZES } from "helpers/helpers"

function Index() {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const date = new Date()

	const reduxAccount = useSelector(state => state.account)
	const reduxFilterData = useSelector(state => state.filterData)

	const [data, setData] = useState({})
	const [statusHistoryId, setStatusHistoryId] = useState(null)
	const [revisionsId, setRevisionsId] = useState(null)
	const [documentStatuses, setDocumentStatuses] = useState([])
	const [poses, setPoses] = useState([])
	const [wms, setWms] = useState([])
	const [suppliers, setSuppliers] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	const [showRightBar, setShowRightBar] = useState({ 'document': false })
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const {
		filterData,
		setFilterData,
		appliedFilterData,
		setAppliedFilterData,
		filterDataExist,
		setFilterDataExist,
		pagination,
		setPagination,
		patchFilterData,
		applySearch,
		applyFilters,
		paginate,
		resetToInitialFilters,
	} = useFilterSearchPagination({
		initialFilterData: {
			start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
			end_date: formatDate(new Date(), 'yyyy-MM-dd'),
			pos_id: reduxAccount.pos_id,
			document_status: 'posted',
			size: 20,
			ids: [],
			search: '',
		},
		initialPagination: { url: '', size: 20, response: null },
	})
	const [modalDelete, setModalDelete] = useState(false)
	const [deleteModalParams, setDeleteModalParams] = useState({ 'id': 0, 'index': 0 })
	const [modalTransfer, setModalTransfer] = useState(false)
	const [transferDocument, setTransferDocument] = useState({})

	async function searchWithFilter(passedData = {}, settings = { reduxData: false }) {
		var filterUrl = "/documents-in"
		var urlParams = ""
		var filterDataCopy = { ...filterData, ...(passedData.filterData || {}) }
		checkFilter(filterDataCopy)

		if (settings?.reduxData) {
			filterDataCopy = reduxFilterData
			urlParams = ""
		}

		if (filterDataCopy.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterDataCopy.pos_id
		if (filterDataCopy.wms_id)
			urlParams += returnSign(urlParams) + 'wms_id=' + filterDataCopy.wms_id
		if (filterDataCopy.supplier_id)
			urlParams += returnSign(urlParams) + 'supplier_id=' + filterDataCopy.supplier_id
		if (filterDataCopy.document_status)
			urlParams += returnSign(urlParams) + 'document_status=' + filterDataCopy.document_status
		if (filterDataCopy.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterDataCopy.start_date
		if (filterDataCopy.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterDataCopy.end_date
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy.size)
			urlParams += returnSign(urlParams) + 'size=' + filterDataCopy.size
		if (filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page
		if (`/documents-in${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams
		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setAppliedFilterData(filterDataCopy)
			setPagination({ ...pagination, 'url': filterUrl, 'size': filterDataCopy.size, 'response': response.data })
			filterDataCopy.url = '/documents-in'
			dispatch(SET_FILTER_DATA(filterDataCopy))
		}

		setDropdownIsOpen(false)
	}

	async function exportExcel() {
		var filterDataCopy = { ...filterData }
		var filterUrl = "/documents-in-excel"
		var urlParams = ""

		if (filterDataCopy.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterDataCopy.pos_id
		if (filterDataCopy.wms_id)
			urlParams += returnSign(urlParams) + 'wms_id=' + filterDataCopy.wms_id
		if (filterDataCopy.supplier_id)
			urlParams += returnSign(urlParams) + 'supplier_id=' + filterDataCopy.supplier_id
		if (filterDataCopy.document_status)
			urlParams += returnSign(urlParams) + 'document_status=' + filterDataCopy.document_status
		if (filterDataCopy.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterDataCopy.start_date
		if (filterDataCopy.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterDataCopy.end_date
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy?.ids?.length)
			urlParams += returnSign(urlParams) + 'ids=' + arrayJoin(filterDataCopy.ids, false)

		filterUrl = filterUrl + urlParams
		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			var excelHeaders = [[t('pos'), t('date'), t('supplier'), t('name2'), t('price'), t('quantity'), t('unit'), t('amount')]]
			var totalAmount = 0
			for (let i = 0; i < response.data.length; i++) {
				var item = response.data[i]
				// Числа пишем числами, а не строками — иначе Excel их не суммирует.
				// Количество не режем до сотых: 0.1299 кг × цену давало другую сумму, чем в документе
				var price = Number(item['price'])
				var quantity = Number(item['quantity'])
				var amount = Math.round(price * quantity * 100) / 100
				totalAmount += amount
				var excelItems = []
				excelItems.push(item['pos_name'])
				excelItems.push(formatDate(item['created_at']))
				excelItems.push(item['supplier_name'])
				excelItems.push(item['element_name'])
				excelItems.push(price)
				excelItems.push(quantity)
				excelItems.push(item['unit_name'])
				excelItems.push(amount)
				excelHeaders.push(excelItems)
			}
			excelHeaders.push(['', '', '', t('total'), '', '', '', Math.round(totalAmount * 100) / 100])

			const ws = XLSX.utils.aoa_to_sheet(excelHeaders);
			// Цена и сумма — с разделителем разрядов, количество — как есть
			for (let r = 1; r < excelHeaders.length; r++) {
				[4, 7].forEach(c => {
					var cell = ws[XLSX.utils.encode_cell({ r, c })]
					if (cell && cell.t === 'n') cell.z = '#,##0.00'
				})
			}
			ws['!cols'] = [{ wch: 20 }, { wch: 12 }, { wch: 22 }, { wch: 32 }, { wch: 14 }, { wch: 10 }, { wch: 8 }, { wch: 16 }]
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
			XLSX.writeFile(wb, t('good_reception') + ".xlsx");
		}
	}

	async function toggleRightbar(boolean = false, item) {
		if (boolean) {
			const response = await GET(`/documents-in/${item.id}`, {}, { loader: true })
			if (httpOk(response)) {
				setSelectedItem(response.data)
				setShowRightBar({ ...showRightBar, 'document': true })
			}
		} else {
			setSelectedItem({})
			setShowRightBar({ ...showRightBar, 'document': false })
		}
	}

	// Перемещение в другую торговую точку на основании прихода. В отличие от филиала,
	// здесь надо выбрать получателя и цену передачи (наценку), поэтому открываем обычную
	// форму перемещения, заполненную составом прихода, — дальше всё как при ручном создании.
	async function transferToPos(item) {
		const response = await GET(`/documents-in/${item.id}`, {}, { loader: true })
		if (!httpOk(response)) return

		// Один товар может стоять в приходе несколькими строками — в перемещении он одной.
		// Map, а не объект: у объекта числовые ключи (id товара) сортируются по возрастанию,
		// и порядок позиций расходился бы с приходом
		const quantities = new Map()
		for (const element of (response.data.items ?? [])) {
			if (Number(element.status) === -1) continue
			quantities.set(element.element_id, (quantities.get(element.element_id) ?? 0) + Number(element.quantity))
		}

		dispatch(SET_TRANSFER_DATA({
			'source_document_in_id': item.id,
			'from_wms_id': response.data.wms_id,
			'note': `${t('transfer_document_in_note')} №${item.id} — ${formatDate(item.created_at, 'dd.MM.yy')}`,
			'items': Array.from(quantities, ([productId, quantity]) => ({
				'product_id': Number(productId),
				'quantity': quantity,
			})),
		}))
		navigate('/service/wms-transfer-pos/create')
	}

	async function deleteItem() {
		const response = await DELETE(`/documents-in/${deleteModalParams.id}`, {}, { loader: true })
		if (httpOk(response)) {
			searchWithFilter()
			setModalDelete(false)
		}
	}

	function handleCheckboxChangeAll(e) {
		var filterDataCopy = { ...filterData }

		filterDataCopy.ids = []
		if (e.target.checked) {
			for (let i = 0; i < data.data.length; i++) {
				filterDataCopy.ids.push(data.data[i]['id'])
			}
		}

		setFilterData(filterDataCopy)
	}

	function handleCheckboxChange(e, id) {
		var filterDataCopy = { ...filterData }

		if (e.target.checked) {
			filterDataCopy.ids.push(id)
		} else {
			filterDataCopy.ids = filterDataCopy.ids.filter(item => item !== id)
		}

		setFilterData(filterDataCopy)
	}

	function resetFilter() {
		resetToInitialFilters((nextFilterData) => {
			searchWithFilter({ filterData: nextFilterData })
		})
		dispatch(SET_FILTER_DATA({}))
	}

	function checkFilter(currentFilterData) {
		if (currentFilterData.search === '') {
			setFilterDataExist(false)
		}
	}

	function handlePaginate(page) {
		paginate(page)
		searchWithFilter({ filterData: { ...filterData, page } })
	}

	function handlePageSizeChange(size) {
		const nextFilterData = { ...filterData, size, page: null }
		patchFilterData({ size, page: null })
		searchWithFilter({ filterData: nextFilterData })
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function getPoses() {
		const response = await GET('/helper/poses', {}, { loader: true })
		if (httpOk(response)) setPoses(response.data)
	}

	async function getSuppliers() {
		const response = await GET('/helper/suppliers', {}, { loader: true })
		if (httpOk(response)) setSuppliers(response.data)
	}

	async function getWms() {
		var filterPosId = filterData.pos_id ? filterData.pos_id : reduxAccount.pos_id
		const response = await GET(`/helper/wms?pos_id=${filterPosId}`)
		if (httpOk(response)) setWms(response.data)
	}

	async function getDocumentStatuses() {
		const response = await GET('/helper/document-statuses?entity=documents_in')
		if (httpOk(response)) setDocumentStatuses(response.data)
	}

	useEffect(() => {
		getPoses()
		getWms()
		getSuppliers()
		getDocumentStatuses()
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('good_reception')} [{data.total}]
				</h4>
				<div className="d-flex">
					<Link className="btn-rounded btn btn-primary" to="/documents-in/create">
						{t('create')}
					</Link>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									value={filterData.search}
									onSearchChange={(search) => applySearch(search, (nextFilterData) => {
										searchWithFilter({ filterData: nextFilterData })
									})}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('pos')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData.pos_id) || ''}
													onChange={(option) => {
														patchFilterData({ 'pos_id': option.id })
														getWms(option.id)
													}}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('suppliers')}</label>
												<Select
													isClearable
													options={suppliers}
													value={suppliers.find(option => option.id === filterData.supplier_id) || ''}
													onChange={(option) => patchFilterData({ 'supplier_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('wms')}</label>
												<Select
													isClearable
													options={wms}
													value={wms.find(option => option.id === filterData.wms_id) || ''}
													onChange={(option) => patchFilterData({ 'wms_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('status')}</label>
												<Select
													isClearable
													options={documentStatuses}
													value={documentStatuses.find(option => option.value === filterData.document_status) || ''}
													onChange={(option) => patchFilterData({ 'document_status': option ? option.value : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => t(option.value)}
													getOptionValue={(option) => option.value}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-12">
												<label>{t('period')}</label>
												<PeriodPicker
													withTime={false}
													startDate={filterData.start_date}
													endDate={filterData.end_date}
													minDate={new Date(new Date().getFullYear() - 1, 0, 1)}
													maxDate={new Date(new Date().getFullYear(), 11, 31)}
													onChange={(period) => patchFilterData(period)}
												/>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary"
														onClick={() => setDropdownIsOpen(false)}>{
															t('cancel')}
													</button>
													<button className="btn btn-primary"
														onClick={() => applyFilters((nextFilterData) => {
															searchWithFilter({ filterData: nextFilterData })
														})}>
														{t('apply')}
													</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							<div>
								<button className="btn btn-outline-primary btn-wide-2"
									onClick={() => exportExcel()}>
									<i className="uil uil-file-download-alt"></i>
								</button>
							</div>
						</div>
						<div className="vertical-center">
							<h4><b>{t('amount')}:</b> {formatMoney(data?.total_amount)}</h4>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(appliedFilterData.start_date || appliedFilterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{appliedFilterData.start_date &&
											<span>{formatDate(appliedFilterData.start_date)}</span>
										}
										{(appliedFilterData.start_date && appliedFilterData.end_date) &&
											<span>|</span>
										}
										{appliedFilterData.end_date &&
											<span>{formatDate(appliedFilterData.end_date)}</span>
										}
									</span>
								}
								{filterData.pos_id &&
									<span className="me-2">
										<b>{t('pos')}: </b>
										{findKeyFromArrayByValue(poses, 'id', filterData.pos_id, 'name')}
									</span>
								}
								{filterData.wms_id &&
									<span className="me-2">
										<b>{t('wms')}: </b>
										{findKeyFromArrayByValue(wms, 'id', filterData.wms_id, 'name')}
									</span>
								}
								{filterData.document_status &&
									<span className="me-2">
										<b>{t('status')}: </b>
										{t(filterData.document_status)}
									</span>
								}
								{filterData.supplier_id &&
									<span className="me-2">
										<b>{t('supplier')}: </b>
										{findKeyFromArrayByValue(suppliers, 'id', filterData.supplier_id, 'name')}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered table-hover mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '25px' }}
										className="text-center">
										<input type="checkbox"
											onChange={(e) => handleCheckboxChangeAll(e)} />
									</th>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '15%' }} className="td-ellipsis">{t('pos')}</th>
									<th style={{ 'width': '15%' }} className="td-ellipsis">{t('wms')}</th>
									<th style={{ 'width': '15%' }} className="td-ellipsis">{t('supplier')}</th>
									<th style={{ 'width': '40%' }}>{t('note')}</th>
									<th style={{ 'minWidth': '115px' }} className="text-nowrap text-center">{t('date')}</th>
									<th style={{ 'width': '15%' }} className="text-nowrap text-end">{t('amount')}</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td>
											<input type="checkbox"
												checked={filterData?.ids?.includes(item.id)}
												onChange={(e) => handleCheckboxChange(e, item.id)} />
										</td>
										<td className={`text-center td-ellipsis ${item.status === -1 ? 'bg-danger text-white' : ''}`}
											title={item.status === -1 ? t('deleted') : ''}>
											{item.row_number}
										</td>
										<td className="td-ellipsis"
											onClick={() => toggleRightbar(true, item)}>
											<span className="text-primary cursor">{item.pos_name}</span>
										</td>
										<td className="td-ellipsis">{item.wms_name}</td>
										<td className="td-ellipsis">{item.supplier_name}</td>
										<td className="td-ellipsis">
											{Number(item.status) === 0 &&
												<span className="badge bg-secondary me-1">{t('draft')}</span>
											}
											{!!item.transfer_branch_id &&
												<span className="badge bg-info me-1">{t('transferred_to_branch')}</span>
											}
											{!!item.transfer_pos_id &&
												<span className="badge bg-info me-1">{t('transferred_to_pos')}</span>
											}
											{item.note}
										</td>
										<td className="text-center">
											{formatDate(item.created_at, 'dd.MM.yy HH:mm')}
										</td>
										<td className="text-end text-nowrap">{formatMoney(item.total_amount)}</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<Link to={`/documents-in/preview/${item.id}`} className="table-dropdown-item">
															<i className="uil-eye"></i>
															{t('preview')}
														</Link>
														{item.editable &&
															<Link to={`/documents-in/update/${item.id}`} className="table-dropdown-item">
																<i className="uil-edit-alt"></i>
																{t('edit')}
															</Link>
														}
														{(Number(item.status) === 1 && !item.transfer_branch_id && !item.transfer_pos_id) &&
															<div className="table-dropdown-item"
																onClick={() => {
																	setTransferDocument(item);
																	setModalTransfer(true)
																}}>
																<i className="uil-exchange"></i>
																{t('transfer_to_branch')}
															</div>
														}
														{(Number(item.status) === 1 && !item.transfer_branch_id && !item.transfer_pos_id) &&
															<div className="table-dropdown-item"
																onClick={() => transferToPos(item)}>
																<i className="uil-share"></i>
																{t('transfer_to_pos')}
															</div>
														}
														<div className="table-dropdown-item"
															onClick={() => setStatusHistoryId(item.id)}>
															<i className="uil-history"></i>
															{t('document_status_history')}
														</div>
														<div className="table-dropdown-item"
															onClick={() => setRevisionsId(item.id)}>
															<i className="uil-file-edit-alt"></i>
															{t('document_revisions')}
														</div>
														{/* Удаление — последним пунктом: промах мимо соседнего пункта дороже всего */}
														{item.deletable &&
															<div className="table-dropdown-item text-danger"
																onClick={() => {
																	setDeleteModalParams({ id: item.id, index: index });
																	setModalDelete(true)
																}}>
																<i className="uil uil-times"></i>
																{t('delete')}
															</div>
														}
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={handlePaginate}
							showPageSizeSelect
							pageSizeOptions={PAGE_SIZES}
							onPageSizeChange={handlePageSizeChange}>
						</FilterPagination>
					}
				</div>
			</div>

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>

			<TransferBranchModal
				show={modalTransfer}
				setShow={setModalTransfer}
				documentIn={transferDocument}
				onSuccess={() => searchWithFilter()}>
			</TransferBranchModal>

			{showRightBar.document &&
				<Rightbar
					showRightBar={showRightBar.document}
					setShowRightBar={setShowRightBar}
					data={selectedItem}>
				</Rightbar>
			}

			<DocumentStatusHistory
				entity="documents_in"
				documentId={statusHistoryId}
				setDocumentId={setStatusHistoryId}>
			</DocumentStatusHistory>

			<DocumentRevisions
				entity="documents_in"
				documentId={revisionsId}
				setDocumentId={setRevisionsId}>
			</DocumentRevisions>
		</>
	)
}

export default Index